import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export class DateUtil {

  static ngbToString(ngb: NgbDateStruct): string | null {
    if (!ngb || !ngb.year) {
      return null;
    }
    return `${ngb.year}-${('00' + ngb.month).slice(-2)}-${('00' + ngb.day).slice(-2)}`;
  }

  static getToday(): NgbDateStruct {
    const today = new Date();
    return {year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate()};
  }

  static stringToNgb(date: string): NgbDateStruct | null {
    const dateParts = (date.match(/\./g)) ? date.trim().split('.') : date.trim().split('-').reverse();
    if (dateParts.length === 3) {
      return {day: Number(dateParts[0]), month: Number(dateParts[1]), year: Number(dateParts[2])};
    } else {
      return null;
    }
  }

  static dayToWeekDay(day: string): string {
    const dayOfWeek = new Date(day).getDay();
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const result = days[dayOfWeek];
    if (result === undefined) {
      throw new Error(`Invalid day: ${day}`);
    }
    return result;
  }

}
